import React from "react";
import ReactDOM from "react-dom";
import { Route, BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import "animate.css";
import App from "./App";
import Select from "./Select";
import Broker from "./Broker";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "mobx-react";
import { Store } from "./store";

const appStore = new Store();

// const RedirectRegion = () => {
//   React.useEffect(() => {
//     window.location.href =
//       "https://limitlessyachts.com/select-your-region-for-configurator/";
//   }, []);

//   return <span></span>;
// };

ReactDOM.render(
  <Provider AppStore={appStore}>
    <Router basename={"/xoboats"}>
      <Route path="/build/:slug/:number" exact component={App} />
      <Route path="/build/:slug" exact component={App} />
      <Route path="/account" exact component={Broker} />
      <Route path="/" exact component={Select} />
      {/* <Route path="/" exact component={Location} /> */}
    </Router>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
